import { render, staticRenderFns } from "./editCube8.vue?vue&type=template&id=19ee2f44&scoped=true&"
import script from "./editCube8.vue?vue&type=script&lang=js&"
export * from "./editCube8.vue?vue&type=script&lang=js&"
import style0 from "./editCube8.vue?vue&type=style&index=0&id=19ee2f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ee2f44",
  null
  
)

export default component.exports